import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 341 341' fill={fillColor} className={className}>
      <path d='M202.270186,170.7 L334.645963,38.3242236 C343.118012,29.8521739 343.118012,15.026087 334.645963,6.55403727 C326.173913,-1.91801242 311.347826,-1.91801242 302.875776,6.55403727 L170.5,138.929814 L38.1242236,6.55403727 C29.6521739,-1.91801242 14.826087,-1.91801242 6.35403727,6.55403727 C-2.11801242,15.026087 -2.11801242,29.8521739 6.35403727,38.3242236 L138.729814,170.7 L6.35403727,302.01677 C-2.11801242,310.48882 -2.11801242,325.314907 6.35403727,333.786957 C10.5900621,338.022981 16.9440994,340.140994 22.2391304,340.140994 C27.5341615,340.140994 33.8881988,338.022981 38.1242236,333.786957 L170.5,201.41118 L302.875776,333.786957 C307.111801,338.022981 313.465839,340.140994 318.76087,340.140994 C324.055901,340.140994 330.409938,338.022981 334.645963,333.786957 C343.118012,325.314907 343.118012,310.48882 334.645963,302.01677 L202.270186,170.7 Z' />
    </svg>
  );
});

export default React.memo(Icon);
